import { render } from "./__AdminSidebar.vue?vue&type=template&id=e38f2ca8&scoped=true"
import script from "./__AdminSidebar.vue?vue&type=script&lang=js"
export * from "./__AdminSidebar.vue?vue&type=script&lang=js"

import "./__AdminSidebar.vue?vue&type=style&index=0&id=e38f2ca8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e38f2ca8"]])

export default __exports__